
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { 
  MEMES, COMIC_BOOK, VIDEOS, TITLES, ROADMAP, 
  ContractAddress, Buy, Socials, 
  ORIGINAL_ART, NDHAUS_PHOTO, TitleArt, Lettering, C, DrawnNav
} from '../kit';
import { FACTS } from '../d/Tokenomics';
import { CONTENT } from '../content';
import { SupplyDonut } from '../kit';

/* ------------------------------------------------------------- Header */
const M5_NAV = [
  { label: 'HOME', href: '#top' },
  { label: 'DOLLARIZE', href: '#dollarize' },
  { label: 'TOKENOMICS', href: '#tokenomics' },
  { label: 'ROADMAP', href: '#roadmap' }
];

export const M5Header = () => (
  <HeaderContainer id="top" className="chapter">
    <div className="nav-wrapper">
      <DrawnNav items={M5_NAV} />
    </div>
    
    <div className="hero-titles">
      <TitleArt src={TITLES.zeus.src} alt={TITLES.zeus.alt} $w="90%" $tilt={2} className="zeus-title" />
    </div>

    <div className="ca-chip">
      <ContractAddress tone="light" />
    </div>
    <div className="buy-btn">
      <Buy big />
    </div>
  </HeaderContainer>
);

const HeaderContainer = styled.header`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: calc(env(safe-area-inset-top) + 28px) 16px max(20px, env(safe-area-inset-bottom));
  background-image: url('/redesign2/scenes/camp.webp');
  background-size: cover;
  background-position: center bottom;
  height: 100dvh;
  width: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;

  .nav-wrapper {
    width: 100%;
    margin-bottom: 10px;
  }

  .hero-titles {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10%;
    gap: 10px;
  }
  
  .zeus-title {
    margin-top: -10px;
  }

  .ca-chip {
    margin-top: auto;
    margin-bottom: 20px;
    z-index: 10;
  }

  .buy-btn {
    z-index: 10;
  }
`;

/* ------------------------------------------------------------- About */
export const M5About1 = () => (
  <Chapter id="about" className="chapter">
    <div className="video-wrap">
      <video src={VIDEOS.trailer.src} poster={VIDEOS.trailer.poster} controls playsInline loop preload="metadata" />
    </div>
    <div className="text-content" style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
      <p>{CONTENT.about.paragraphs[0]}</p>
    </div>
  </Chapter>
);

export const M5About2 = () => (
  <Chapter className="chapter" style={{ padding: 0, justifyContent: 'flex-end' }}>
    <img src="/redesign2/scenes/camp.webp" alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', zIndex: 0, opacity: 0.8 }} />
    <div className="text-content" style={{ position: 'relative', zIndex: 1, background: 'rgba(255, 251, 238, 0.95)', padding: 'calc(env(safe-area-inset-top) + 24px) 20px max(24px, env(safe-area-inset-bottom))', borderTop: `4px solid ${C.ink}`, margin: 0, width: '100%', boxSizing: 'border-box' }}>
      {CONTENT.about.paragraphs.slice(1).map((p, i, arr) => {
        if (i === arr.length - 1) {
          const [before] = p.split('has officially secured trademark');
          return (
            <p key={i}>
              {before}
              <a href={CONTENT.about.trademarkLink} target="_blank" rel="noopener noreferrer">
                has officially secured trademark protection
              </a>
              {' '}over the $ZEUS name...
            </p>
          );
        }
        return <p key={i}>{p}</p>;
      })}
    </div>
  </Chapter>
);

/* ------------------------------------------------------------- Takeover */
export const M5Takeover1 = () => (
  <Chapter id="takeover" $bg={C.mist} className="chapter">
    <TitleArt src={TITLES.takeOver.src} alt={TITLES.takeOver.alt} $w="90%" />
    <div className="video-wrap" style={{ margin: '16px 0' }}>
      <video src={VIDEOS.buy.src} poster={VIDEOS.buy.poster} controls playsInline loop preload="metadata" />
    </div>
    <div className="text-content" style={{ flex: 1, display: 'flex', alignItems: 'center', margin: 0 }}>
      <p style={{ margin: 0 }}>{CONTENT.aboutCto.paragraphs[0]}</p>
    </div>
  </Chapter>
);

export const M5Takeover2 = () => (
  <Chapter $bg={C.mist} className="chapter" style={{ padding: 0, justifyContent: 'flex-end' }}>
    <img src="/redesign2/scenes/gang.webp" alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', zIndex: 0 }} />
    <div className="text-content" style={{ position: 'relative', zIndex: 1, background: 'rgba(255, 255, 255, 0.95)', padding: '24px 20px max(24px, env(safe-area-inset-bottom))', borderTop: `4px solid ${C.ink}`, margin: 0, width: '100%', boxSizing: 'border-box' }}>
      {CONTENT.aboutCto.paragraphs.slice(1).map((p, i) => (
        <p key={i} style={{ margin: i === 1 ? 0 : '0 0 16px 0' }}>{p}</p>
      ))}
    </div>
  </Chapter>
);

/* ------------------------------------------------------------- Tokenomics */
export const M5Tokenomics1 = () => (
  <Chapter id="tokenomics" $bg={C.yellow} className="chapter" style={{ paddingBottom: 'max(10px, env(safe-area-inset-bottom))' }}>
    <TitleArt src={TITLES.tokenomics.src} alt={TITLES.tokenomics.alt} $w="90%" style={{ marginBottom: 10 }} />
    <div className="donut-wrap" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, width: '100%' }}>
      <div style={{ transform: 'scale(0.9)', transformOrigin: 'center' }}>
        <SupplyDonut size={200} />
      </div>
    </div>
  </Chapter>
);

export const M5Tokenomics2 = () => (
  <Chapter $bg={C.yellow} className="chapter" style={{ justifyContent: 'center' }}>
    <div className="treasure-scatter" style={{ marginTop: 0 }}>
      {FACTS.map((f, i) => (
        <a key={f.key} href={f.link} target="_blank" rel="noopener noreferrer" className="treasure-item">
          <img src={f.art} alt="" className="treasure-art" />
          <Lettering $size="26px" $tilt={i % 2 === 0 ? -2 : 2}>{f.big}</Lettering>
          <span className="fact-label">{f.label}</span>
        </a>
      ))}
    </div>
  </Chapter>
);

/* ------------------------------------------------------------- Dollarize */
export const M5Dollarize1 = () => (
  <Chapter id="dollarize" $bg={C.ink} $color={C.white} className="chapter">
    <img src="/redesign2/scenes/blackhole.webp" alt="Blackhole" className="hero-img" style={{ flex: 1, objectFit: 'cover', minHeight: 0, marginBottom: 16 }} />
    <Lettering $size="32px" style={{ marginBottom: 16 }}>{CONTENT.dollarize.title}</Lettering>
    <div className="text-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBottom: 0 }}>
      {CONTENT.dollarize.paragraphs.slice(0, 2).map((p, i) => (
        <p key={i} style={{ margin: i === 1 ? 0 : '0 0 12px 0' }}>{p}</p>
      ))}
    </div>
  </Chapter>
);

export const M5Dollarize2 = () => (
  <Chapter $bg={C.ink} $color={C.white} className="chapter" style={{ padding: 0, justifyContent: 'flex-end' }}>
    <img src="/redesign2/scenes/blackhole.webp" alt="Blackhole" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0, opacity: 0.5 }} />
    <div style={{ position: 'relative', zIndex: 1, background: 'rgba(14,27,51,0.9)', padding: '32px 20px max(40px, env(safe-area-inset-bottom))', borderTop: `4px solid ${C.ink}`, width: '100%', boxSizing: 'border-box' }}>
      <div className="text-content" style={{ marginBottom: 24 }}>
        {CONTENT.dollarize.paragraphs.slice(2).map((p, i) => (
          <p key={i} style={{ margin: i === 1 ? 0 : '0 0 16px 0', textShadow: `1px 1px 2px ${C.ink}` }}>{p}</p>
        ))}
      </div>
      <div className="btn-row">
        <ActionBtn href={CONTENT.dollarize.mintLink} target="_blank" rel="noopener noreferrer">MINT</ActionBtn>
        <ActionBtn href={CONTENT.dollarize.howLink} target="_blank" rel="noopener noreferrer" $outline>HOW IT WORKS</ActionBtn>
      </div>
    </div>
  </Chapter>
);

/* ------------------------------------------------------------- Roadmap */
export const M5Roadmap1 = () => {
  const latest = [...ROADMAP].reverse().slice(0, 2);
  return (
    <Chapter id="roadmap" $bg={C.paper} className="chapter">
      <TitleArt src={TITLES.roadmap.src} alt={TITLES.roadmap.alt} $w="80%" style={{ marginBottom: 20 }} />
      <div style={{ flex: 1, display: 'flex', width: '100%', overflow: 'hidden' }}>
        <ol className="road-path" style={{ margin: 0, width: '100%' }}>
          {latest.map((stop, i) => (
            <li key={i} className={i === 0 ? "planned" : "done"}>
              <div className="dot"/>
              <div className="content">
                <span className="pill">{stop.pill}</span>
                <h3>{stop.lines.map((l, j) => <span key={j} style={{display: 'block'}}>{l}</span>)}</h3>
                {stop.milestone?.description && <p style={{ fontSize: 14 }}>{stop.milestone.description}</p>}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </Chapter>
  );
};

export const M5Roadmap2 = () => {
  const rest = [...ROADMAP].reverse().slice(2);
  const visibleRest = rest.slice(0, 2);
  const foldedRest = rest.slice(2);
  return (
    <Chapter $bg={C.paper} className="chapter" style={{ paddingTop: 'calc(env(safe-area-inset-top) + 28px)' }}>
      <div style={{ flex: 1, display: 'flex', width: '100%', overflow: 'hidden' }}>
        <ol className="road-path" style={{ margin: 0, width: '100%' }}>
          {visibleRest.map((stop, i) => (
            <li key={i} className="done">
              <div className="dot"/>
              <div className="content">
                <span className="pill">{stop.pill}</span>
                <h3>{stop.lines.map((l, j) => <span key={j} style={{display: 'block'}}>{l}</span>)}</h3>
                {stop.milestone?.description && <p style={{ fontSize: 14 }}>{stop.milestone.description}</p>}
              </div>
            </li>
          ))}
          {foldedRest.length > 0 && (
            <li className="folded" style={{ paddingBottom: 0 }}>
              <div className="line-dashed" />
              <details className="fold-details">
                <summary>View past milestones</summary>
                <div className="fold-content">
                  {foldedRest.map((m, i) => (
                    <div key={i} className="middle-item">
                      <span className="pill">{m.pill}</span>
                      <h4>{m.lines.join(' ')}</h4>
                    </div>
                  ))}
                </div>
              </details>
            </li>
          )}
        </ol>
      </div>
    </Chapter>
  );
};

/* ------------------------------------------------------------- Artist */
export const M5Artist1 = () => (
  <Chapter id="artist" $bg={C.light} className="chapter">
    <TitleArt src={TITLES.artist.src} alt={TITLES.artist.alt} $w="80%" style={{ marginBottom: 16 }} />
    <img src={NDHAUS_PHOTO} alt="ndhaus" className="hero-img artist-img" style={{ flex: 1, minHeight: 0, marginBottom: 16 }} />
    <div className="text-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBottom: 0 }}>
      {CONTENT.artist.paragraphs.slice(0, 2).map((p, i) => (
        <p key={i} style={{ margin: i === 1 ? 0 : '0 0 12px 0' }}>{p}</p>
      ))}
    </div>
  </Chapter>
);

export const M5Artist2 = () => (
  <Chapter $bg={C.light} className="chapter" style={{ padding: 0, justifyContent: 'flex-end' }}>
    <img src={ORIGINAL_ART} alt="Original Zeus Art" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '70%', objectFit: 'cover', objectPosition: 'center top', zIndex: 0 }} />
    <div className="text-content" style={{ position: 'relative', zIndex: 1, background: 'rgba(244, 241, 233, 0.95)', padding: '24px 20px max(24px, env(safe-area-inset-bottom))', borderTop: `4px solid ${C.ink}`, margin: 0, width: '100%', boxSizing: 'border-box' }}>
      {CONTENT.artist.paragraphs.slice(2).map((p, i, arr) => (
        <p key={i} style={{ margin: i === arr.length - 1 ? 0 : '0 0 16px 0' }}>{p}</p>
      ))}
    </div>
  </Chapter>
);

/* ------------------------------------------------------------- NFTs */
export const M5Nfts1 = () => (
  <Chapter id="nfts" $bg={C.ink} $color={C.white} className="chapter">
    <Lettering $size="32px" style={{ marginBottom: 16 }}>{CONTENT.nfts.title}</Lettering>
    <div className="text-content" style={{ marginBottom: 16 }}>
      {CONTENT.nfts.paragraphs.map((p, i) => (
        <p key={i} style={{ margin: i === 1 ? 0 : '0 0 12px 0' }}>{p}</p>
      ))}
    </div>
    <img src="/redesign2/nfts/hero.webp" alt="Dreamscape Hero" className="hero-img" style={{ flex: 1, minHeight: 0, marginBottom: 0, marginTop: 'auto' }} />
  </Chapter>
);

export const M5Nfts2 = () => (
  <Chapter $bg={C.ink} $color={C.white} className="chapter" style={{ padding: 0, justifyContent: 'center' }}>
    <img src={`/redesign2/nfts/${CONTENT.nfts.items[0]}.webp`} alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0, opacity: 0.25, filter: 'blur(8px)' }} />
    <div style={{ position: 'relative', zIndex: 1, width: '100%', padding: '24px 20px max(24px, env(safe-area-inset-bottom))', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div className="nft-grid" style={{ width: '100%', marginBottom: 30 }}>
        {CONTENT.nfts.items.slice(0, 4).map(id => (
          <img key={id} src={`/redesign2/nfts/${id}.webp`} alt="" />
        ))}
      </div>
      <ActionBtn href={CONTENT.nfts.link} target="_blank" rel="noopener noreferrer">VIEW ON OPENSEA</ActionBtn>
    </div>
  </Chapter>
);

/* ------------------------------------------------------------- Memes */
export const M5Memes = () => {
  const [active, setActive] = useState(0);
  return (
    <Chapter id="memes" $bg={C.sky} className="chapter" style={{ paddingLeft: 0, paddingRight: 0, backgroundImage: "url('/redesign2/scenes/swamp-empty.webp')", backgroundSize: 'cover', backgroundPosition: 'center', justifyContent: 'center' }}>
      <TitleArt src={TITLES.memes.src} alt={TITLES.memes.alt} $w="80%" style={{ marginBottom: 16, zIndex: 1, filter: `drop-shadow(2px 4px 0 ${C.ink})` }} />
      <HScroll onScroll={(e) => {
        const el = e.currentTarget;
        const idx = Math.round(el.scrollLeft / (window.innerWidth * 0.86)); // 82% + 4% gap
        setActive(idx);
      }}>
        {MEMES.map((m, i) => (
          <div key={i} className="meme-slide" style={{ width: '82vw', marginLeft: i === 0 ? '9vw' : '2vw', marginRight: i === MEMES.length - 1 ? '9vw' : '2vw', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, scrollSnapAlign: 'center' }}>
            <img src={m.src} alt={m.alt} loading="lazy" style={{ width: '100%', height: 'auto', maxHeight: '55vh', objectFit: 'contain', border: `4px solid ${C.ink}`, borderRadius: 16, backgroundColor: C.ink, boxShadow: `4px 4px 0 ${C.ink}` }} />
          </div>
        ))}
      </HScroll>
      <div style={{ marginTop: 16, fontFamily: 'GROBOLD', fontSize: 20, color: C.white, textShadow: `2px 2px 0 ${C.ink}, -1px -1px 0 ${C.ink}, 1px -1px 0 ${C.ink}, -1px 1px 0 ${C.ink}, 1px 1px 0 ${C.ink}`, zIndex: 1 }}>{active + 1} / {MEMES.length}</div>
    </Chapter>
  );
};

/* ------------------------------------------------------------- Comic */
export const M5Comic = ({ openComic }: { openComic: () => void }) => {
  const [active, setActive] = useState(0);
  return (
    <Chapter id="comic" $bg={C.paper} className="chapter" style={{ paddingLeft: 0, paddingRight: 0, justifyContent: 'center' }}>
      <TitleArt src={TITLES.comic.src} alt={TITLES.comic.alt} $w="90%" style={{ marginBottom: 10 }} />
      <p style={{textAlign: 'center', margin: '0 20px 10px', fontSize: 14}}>{CONTENT.comic.subtitle}</p>
      <HScroll onScroll={(e) => {
        const el = e.currentTarget;
        const idx = Math.round(el.scrollLeft / (window.innerWidth * 0.9)); // 86vw + 4vw gap
        setActive(idx);
      }}>
        {COMIC_BOOK.map((m, i) => (
          <div key={i} onClick={openComic} style={{ width: '86vw', marginLeft: i === 0 ? '7vw' : '2vw', marginRight: i === COMIC_BOOK.length - 1 ? '7vw' : '2vw', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, scrollSnapAlign: 'center' }}>
            <img src={m.src} alt="Comic page" loading="lazy" style={{ width: '100%', height: 'auto', maxHeight: '60vh', border: `4px solid ${C.ink}`, backgroundColor: C.white, boxShadow: `4px 4px 0 ${C.ink}` }} />
          </div>
        ))}
      </HScroll>
      <div style={{ marginTop: 16, fontFamily: 'GROBOLD', fontSize: 20, display: 'flex', alignItems: 'center', gap: 16 }}>
        <span>{active + 1} / {COMIC_BOOK.length}</span>
        <ActionBtn href="/zeus.pdf" download $outline style={{ minHeight: 36, fontSize: 14, padding: '0 16px' }}>DOWNLOAD (PDF)</ActionBtn>
      </div>
    </Chapter>
  );
};

/* ------------------------------------------------------------- Join & Footer */
export const M5Join = () => (
  <Chapter id="join" $bg={C.blue} className="chapter" style={{ padding: 0 }}>
    <div style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 'calc(env(safe-area-inset-top) + 28px) 20px 0' }}>
      <img src="/redesign2/scenes/gang.webp" alt="The gang" className="hero-img gang-img" style={{ flex: 1, objectFit: 'contain', objectPosition: 'center', border: 'none', background: 'transparent', margin: 0 }} />
    </div>
    <div style={{ width: '100%', background: C.ink, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px 20px max(20px, env(safe-area-inset-bottom))', borderTop: `4px solid ${C.ink}` }}>
      <div className="btn-row" style={{ marginBottom: 20 }}>
        <Buy big />
      </div>
      <Socials color={C.white} size={30} className="socials-bottom" />
      <FooterWrap>
        <img src="/assets/img/logo.webp" alt="Logo" className="logo" style={{ filter: 'brightness(0) invert(1)', width: 40, height: 40, marginBottom: 12 }} />
        <div className="links">
          <a href="/terms">Terms</a>
          <a href="/privacy">Privacy</a>
        </div>
      </FooterWrap>
    </div>
  </Chapter>
);

/* ------------------------------------------------------------- Styles */

const Chapter = styled.section<{ $bg?: string; $color?: string }>`
  width: 100%;
  height: 100dvh;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: calc(env(safe-area-inset-top) + 28px) 20px max(20px, env(safe-area-inset-bottom));
  background: ${(p) => p.$bg || C.white};
  color: ${(p) => p.$color || C.ink};
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  font-family: 'Ubuntu', sans-serif;

  .video-wrap {
    width: 100%;
    margin: 24px 0;
    border: 4px solid ${C.ink};
    border-radius: 16px;
    overflow: hidden;
    background: #000;
    flex-shrink: 0;
  }
  
  video {
    width: 100%;
    display: block;
    max-height: 35vh;
    object-fit: cover;
  }

  .text-content {
    font-size: 18px;
    line-height: 1.4;
    margin-bottom: 24px;
    width: 100%;
    p { margin: 0 0 16px 0; }
    a { color: inherit; font-weight: bold; }
  }

  .hero-img {
    width: 100%;
    border: 4px solid ${C.ink};
    border-radius: 20px;
    margin-bottom: 24px;
    background: ${C.white};
    max-height: 40vh;
    object-fit: cover;
  }

  .donut-wrap {
    margin: 30px 0;
    
    /* tokenomics fix for 360x740 */
    .foot {
      font-size: 14px;
      line-height: 1.3;
      margin-top: 10px;
      text-align: center;
    }
  }

  .treasure-scatter {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px 12px;
    margin-top: 10px;
    width: 100%;
  }
  .treasure-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    text-decoration: none;
    color: ${C.ink};
    justify-content: flex-end;
    min-height: 140px;
    
    .treasure-art {
      width: 90px;
      height: auto;
      margin-bottom: 5px;
      z-index: 2;
    }
    .fact-label { 
      font-family: 'GROBOLD', sans-serif; 
      font-size: 14px; 
      margin-top: 4px;
    }
  }

  .btn-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
  }
  
  .road-path {
    list-style: none;
    padding: 0;
    margin: 20px 0 0;
    width: 100%;
    
    li {
      position: relative;
      padding: 0 0 30px 40px;
    }
    
    .dot {
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
      border: 3px solid ${C.ink};
      border-radius: 50%;
      background: ${C.yellow};
    }
    
    li.planned .dot { background: ${C.white}; }
    
    li:not(:last-child)::before {
      content: '';
      position: absolute;
      left: 10px;
      top: 24px;
      bottom: -10px;
      width: 4px;
      background: ${C.ink};
    }
    
    li.folded::before {
      background: transparent;
      border-left: 4px dashed ${C.ink};
    }
    
    .fold-details {
      margin-left: -20px;
      padding: 10px 0;
    }
    .fold-details summary {
      cursor: pointer;
      font-weight: bold;
      color: ${C.ink};
    }
    .fold-content {
      margin-top: 10px;
      padding-left: 20px;
      border-left: 4px dashed rgba(14, 27, 51, 0.3);
    }
    .middle-item {
      margin-bottom: 16px;
      h4 { margin: 4px 0 0; font-family: 'GROBOLD', sans-serif; font-size: 16px; }
    }
    
    .pill {
      display: inline-block;
      padding: 2px 10px;
      background: ${C.yellow};
      border: 2px solid ${C.ink};
      border-radius: 999px;
      font-family: 'GROBOLD', sans-serif;
      font-size: 12px;
      margin-bottom: 8px;
    }
    
    h3 { margin: 0 0 8px; font-family: 'GROBOLD', sans-serif; }
    p { margin: 0; font-size: 16px; }
  }

  .nft-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 24px;
    img { width: 100%; border-radius: 12px; border: 3px solid ${C.ink}; boxShadow: 4px 4px 0 ${C.ink}; }
  }

  .socials-bottom {
    margin: 0 0 20px 0;
  }
`;

const HScroll = styled.div`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  width: 100vw;
  max-width: 430px;
  flex: 1;
  min-height: 0;
  &::-webkit-scrollbar { display: none; }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ActionBtn = styled.a<{ $outline?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 24px;
  font-family: 'GROBOLD', sans-serif;
  font-size: 18px;
  color: ${(p) => p.$outline ? C.ink : C.ink};
  background: ${(p) => p.$outline ? C.white : C.yellow};
  border: 3px solid ${C.ink};
  border-radius: 999px;
  text-decoration: none;
  box-shadow: 3px 4px 0 ${C.ink};
  cursor: pointer;
  
  &:active {
    transform: translate(2px, 2px);
    box-shadow: 1px 2px 0 ${C.ink};
  }
`;

const FooterWrap = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${C.white};
  
  .links {
    display: flex;
    gap: 20px;
    a { color: ${C.white}; font-weight: bold; text-decoration: none; font-size: 14px; }
  }
`;
